module.exports = __webpack_public_path__ + "static/understanding-identity-ad478b22ef19222cb54cdd3002f802b2.jpg";